export default __webpack_public_path__ + "static/media/metal-card4x-min.4707fd88.webp";